import React from 'react'
import AccountIcon from 'react-icons/lib/md/account-circle'
import StatusBadge from '../StatusBadge'

import styles from './styles.css'

export default function UserAvatar({userName, active, small}) {
  const iconSize = small ? 28 : 32
  return (
    <div className={styles.container}>
      {userName ? (
        <div className={[styles.userInitials, small && styles.small].filter(Boolean).join(' ')}>
          <span>
            {userName
              .split(' ')
              .map(name => name[0].toUpperCase())
              .join('')}
          </span>
        </div>
      ) : (
        <AccountIcon size={iconSize} />
      )}
      {userName ? (
        <div className={[styles.badge, small && styles.small].filter(Boolean).join(' ')}>
          <StatusBadge active={active} small={small} />
        </div>
      ) : null}
    </div>
  )
}
